import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

/**
 * Custom Dashboard Icon component using the provided SVG path
 * 
 * @param {Object} props - Component props from SvgIcon
 * @returns {JSX.Element} Custom dashboard icon SVG component
 */
const CustomDashboardIcon = (props) => {
  return (
    <SvgIcon viewBox="0 0 23.899 23.899" {...props}>
      <path 
        id="bxs-dashboard" 
        d="M5.828,17.777h7.966a1.328,1.328,0,0,0,1.328-1.328V5.828A1.328,1.328,0,0,0,13.794,4.5H5.828A1.328,1.328,0,0,0,4.5,5.828V16.45A1.328,1.328,0,0,0,5.828,17.777ZM4.5,27.072A1.328,1.328,0,0,0,5.828,28.4h7.966a1.328,1.328,0,0,0,1.328-1.328V21.761a1.328,1.328,0,0,0-1.328-1.328H5.828A1.328,1.328,0,0,0,4.5,21.761Zm13.277,0A1.328,1.328,0,0,0,19.105,28.4h7.966A1.328,1.328,0,0,0,28.4,27.072V17.777a1.328,1.328,0,0,0-1.328-1.328H19.105a1.328,1.328,0,0,0-1.328,1.328Zm1.328-13.277h7.966A1.328,1.328,0,0,0,28.4,12.466V5.828A1.328,1.328,0,0,0,27.072,4.5H19.105a1.328,1.328,0,0,0-1.328,1.328v6.639A1.328,1.328,0,0,0,19.105,13.794Z" 
        transform="translate(-4.5 -4.5)" 
        fill={props.fill || "white"}
      />
    </SvgIcon>
  );
};

export default CustomDashboardIcon;